export enum CameraActions {
  UPDATE = "update",
  CREATE = "create",
  GET = "get",
  DELETE = "delete",
  LIST = "list",
  REORDER = "reorder",
  BARCODE = "barcode"
}